import React from 'react'
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import { Button } from 'src/components/ui/button';
import OneDriveEdits from './OneDriveEdits';
import { useMS } from 'src/components/files/onedrive/context/MSContext';
import { requestScopes } from 'src/authConfig';
import EmptyState from 'src/components/layout/EmptyState';
import { KeyRoundIcon } from 'lucide-react';

const OneDrive = () => {
    const { instance } = useMsal();
    const { setaccessToken } = useMS()

    const handleLogin = (loginType:string) => {
        if (loginType === "popup") {
            instance.loginPopup(requestScopes).catch(e => {
                console.log(e);
            }).then((response) => { if(response){ setaccessToken(response.accessToken) } })
        } else if (loginType === "redirect") {
            instance.loginRedirect(requestScopes).catch(e => {
                console.log(e);
            })
        }
    }

  return (
    <div className='max-w-3xl flex-grow'>
        <h3 className="font-semibold text-neutral-600 mb-2">Openstaande bewerkte documenten</h3>
        <UnauthenticatedTemplate>
            <EmptyState
                icon={<KeyRoundIcon className='w-6 h-6' strokeWidth={1.5}/>}
                title='Inloggen bij Microsoft'
                description='Gelieve in te loggen in uw Microsoft account'
            >
                <Button onClick={() => handleLogin("popup")} variant='outline' className='gap-2'>Inloggen</Button>
            </EmptyState>
            
        </UnauthenticatedTemplate>
        <AuthenticatedTemplate>
            <OneDriveEdits />
        </AuthenticatedTemplate>
    </div>
  )
}

export default OneDrive